/* SeeMy — accessibilité : contrôle des vidéos en lecture automatique (WCAG 2.2.2) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4l13 8-13 8z"/></svg>';

  function setup(video) {
    if (video.dataset.smA11y) return;
    video.dataset.smA11y = '1';
    var host = video.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-video-toggle';
    function render() {
      var paused = video.paused;
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Lire la vidéo d’arrière-plan' : 'Mettre en pause la vidéo d’arrière-plan');
      btn.innerHTML = (paused ? ICON_PLAY : ICON_PAUSE) + '<span>' + (paused ? 'Lecture' : 'Pause') + '</span>';
    }
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
    });
    video.addEventListener('play', render);
    video.addEventListener('pause', render);
    if (reduce) { video.removeAttribute('autoplay'); video.pause(); }
    host.appendChild(btn);
    render();
  }

  function init() {
    document.querySelectorAll('video[autoplay], video[loop]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* SeeMy — boutons flottants : réserver un soin (Planity) + WhatsApp (repris du WordPress) */
(function () {
  if (document.querySelector('.sm-float')) return;
  var PLANITY = 'https://www.planity.com/seemy-cosmetics-75008-paris';
  var WHATSAPP = 'https://wa.me/33766481819';
  var wrap = document.createElement('div');
  wrap.className = 'sm-float';
  if (document.querySelector('main[data-template*="product"]')) wrap.classList.add('sm-float--product');
  wrap.innerHTML =
    '<a class="sm-float__book" href="' + PLANITY + '" target="_blank" rel="noopener">' +
      '<span class="sm-float__long">Réserver un soin</span><span class="sm-float__short">Réserver</span>' +
      '<span class="visually-hidden"> (nouvelle fenêtre)</span></a>' +
    '<a class="sm-float__wa" href="' + WHATSAPP + '" target="_blank" rel="noopener" aria-label="Nous écrire sur WhatsApp (nouvelle fenêtre)">' +
      '<svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><path fill="currentColor" d="M16.04 3C9 3 3.3 8.7 3.3 15.74c0 2.25.59 4.44 1.7 6.37L3.2 28.8l6.86-1.8a12.7 12.7 0 0 0 5.97 1.52h.01c7.03 0 12.74-5.7 12.74-12.74 0-3.4-1.33-6.6-3.73-9A12.66 12.66 0 0 0 16.04 3zm0 23.37h-.01c-1.9 0-3.77-.51-5.4-1.48l-.39-.23-4.07 1.07 1.09-3.97-.25-.41a10.55 10.55 0 0 1-1.62-5.62c0-5.85 4.76-10.6 10.61-10.6 2.83 0 5.49 1.1 7.49 3.11a10.53 10.53 0 0 1 3.1 7.5c0 5.85-4.76 10.6-10.55 10.63zm5.82-7.94c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.32-.82 1.03-1 1.24-.18.21-.37.24-.69.08-.32-.16-1.34-.49-2.56-1.57-.95-.84-1.59-1.88-1.77-2.2-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65s1.14 3.08 1.3 3.29c.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z"/></svg></a>';
  function add() { document.body.appendChild(wrap); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();
